export const ASRS5 = 
{
    Metadata:{Name:'ASRS-5',maxColumn:5,numRows:6},
    Sections:
    [
        {
            Headers:[
                "Check the box that best describes how you have felt and conducted yourself <span class='importantText'>over the past 6 months.</span>",
                "Never",
                "Rarely",
                "Sometimes",
                "Often",
                "Very Often"
            ],
            Questions:[
                {
                    Prompt:"1. How often do you have difficulty concentrating on what other people are saying to you even when they are speaking to you directly?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"2. How often do you leave your seat in meetings or other situations in which you are expected to remain seated?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"3. How often do you have difficulty unwinding and relaxing when you have time to yourself?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"4. When you are in a conversation, how often do you find yourself finishing the sentences of the people you are talking to before they can finish them themselves",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"5. How often do you put things off until the last minute?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
                {
                    Prompt:"6. How often do you depend on others to keep your life in order and attend to details?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"}
                    ]
                },
            ]
        }
    ]
}